import axios from 'axios';
import api from './ApiAuthService';

export default class About {
  static async getAbout() {
    try {
      let url = '/ambassadors';
      const response = await api.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  }


}